<template>
  <div class="shop-area-selector__wrap">
    <yxt-select
      id="BelongAreaSelect"
      style="width: 100%;"
      :value="value"
      :placeholder="$t(place)"
      hidden-option
      value-key="id"
      prop-label="areaName"
      @visible-change="switchOptionsPanel"
    >
      <template
        slot="tag"
        slot-scope="{ data }"
      >
        <span>{{ data.currentLabel }}</span>
      </template>
    </yxt-select>
    <transition name="yxt-zoom-in-top">
      <div
        v-show="customOptionsVisible"
        id="CustomOptions"
        class="yxtbiz-shop-custom-options__wrap"
        @mousedown.stop="noop"
      >
        <yxt-input
          v-model.trim="filterText"
          :placeholder="
            $t('pc_biz_shoptour_input_search_area' /* 请输入区域名称模糊搜索 */)
          "
          searchable
          clearable
          @clear="search"
          @search="search"
        />
        <yxt-tree
          ref="tree"
          style="height: 240px; overflow: hidden;"
          node-key="id"
          :empty-text="$t('pc_biz_shoptour_no_data' /* 暂无数据 */)"
          class="filter-tree mt10"
          wrap-width="100%"
          :default-expand-all="false"
          :default-expanded-keys="expendedRoot"
          virtual
          :data="areaList"
          :props="defaultProps"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          :render-content="renderContent"
          @node-click="handleNodeClick"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { getAreaList } from '../service';

export default {
  name: 'AreaSelector',
  props: {
    value: {
      type: [String, Array, Number, Object]
    },
    place: {
      type: String,
      default: 'pc_biz_shoptour_please_select' // 请选择
    },
    filterNodeId: {
      type: String || Number,
      default: null
    }
  },
  data() {
    return {
      filterText: '',
      areaList: [],
      defaultProps: {
        children: 'children',
        label: 'areaName'
      },
      expendedRoot: [], // 默认展开根元素
      customOptionsVisible: false
    };
  },
  methods: {
    /**
     * 获取区域树
     */
    async getTreeList() {
      this.loading = true;
      try {
        const {datas} = await getAreaList(this.filterNodeId);
        this.areaList = datas;
        this.$nextTick(() => {
          if (datas[0]) {
            this.expendedRoot = [datas[0].id];
          }
        });
        this.loading = false;
      } catch ({error}) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.areaName.indexOf(value) !== -1;
    },
    search(value) {
      this.$refs.tree.filter(value);
    },
    handleNodeClick(data, node) {
      this.customOptionsVisible = false;
      this.$emit('input', data);
      this.$emit('change', data);
      this.mockClick();
    },
    switchOptionsPanel(status) {
      this.customOptionsVisible = status;
      if (status) {
        this.filterText = '';
        !this.value && this.getTreeList();
      }
    },
    renderContent(h, { node, data, store }) {
      const jsx = (
        <span class="custom-tree-node pr10" slot-scope="{ node, data }">
          <yxt-tooltip effect="dark" placement="top-start">
            <yxtbiz-dept-name slot="content" name={node.label} />
            <span>
              <yxtbiz-dept-name name={node.label} />
            </span>
          </yxt-tooltip>
        </span>
      );
      return jsx;
    },
    /**
     * 空函数，阻止下拉展示中点击搜索框，触发收回
     */
    noop() {},
    /**
     * 模拟点击关闭弹窗，为了解决下拉框中的树结构无法点击缩略
     */
    mockClick() {
      const dom = document.getElementById('BelongAreaSelect');
      dom.click();
    }
  }
};
</script>
